export default __webpack_public_path__ + "static/media/Hemkunskap6.3212fc6a.jpeg";